import {Link, useParams} from 'react-router-dom'
import {useEffect, useState} from "react"
import classes from "./Shitster.module.css"
import Button from "react-bootstrap/Button"
import Container from "react-bootstrap/Container"
import Stack from "react-bootstrap/Stack"
import axios from "axios"

function ShitsterPlayer({token, player, deviceId, paused}) {
  let { songId } = useParams();
  const [id, setId] = useState("")
  const [revealed, setRevealed] = useState(false)
  const [title, setTitle] = useState("-")
  const [artist, setArtist] = useState("-")
  const [year, setYear] = useState("-")
  const [position, setPosition] = useState(0)

  useEffect(() => {
    if (!player) return
    const interval = setInterval(() => {
        player.getCurrentState().then(state => {
          if (!state) {
            console.error('User is not playing music through the Web Playback SDK');
            return;
          }
          setPosition(state.position)
        });
      }, 500);
      return () => clearInterval(interval);
    }, [player]
  );

  useEffect(() => {
    if (!id || !token || !player || !deviceId ) return
    fetch(
      `https://api.spotify.com/v1/me/player/play?device_id=${deviceId}`,
      {
        method: "PUT",
        body: JSON.stringify({ uris: ["spotify:track:" + id] }),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    ).then(d => console.log("Playing track")).catch(e => console.log("Error playing track: " + e));

    return () => {player.pause()}
  }, [deviceId, id, token, player])

  useEffect(() => {
    if (!id || !token) return

    // Get track data
    axios.get("https://api.spotify.com/v1/tracks/" + id, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(data => {
      const artist = data.data.artists && data.data.artists[0]
      setArtist(artist && artist.name)
      setTitle(data.data.name)
      setYear(data.data.album.release_date.replaceAll('-', '. '))
    }).catch(function (e) {
      console.log("Failed to get track data")
      console.log(e)
    })
  }, [id, token])

  useEffect(() => {
    setId(songId)
  }, [songId])

  return ( deviceId ? <Container>

    { player && <div>
      <table className={'mx-auto'}>
        <tbody>
          <tr>
            <td><Button variant={'link'} className={classes.ControlButton} onClick={e => {
              player.seek(Math.max(0, position - 5000))
            }}>⏪</Button></td>
            <td><Button variant={'link'} className={classes.ControlButton} onClick={e => {
              paused ? player.resume() : player.pause()
            }}>{paused ? "▶️️" : "⏸"}️️</Button></td>
            <td><Button variant={'link'} className={classes.ControlButton} onClick={e => {
              player.seek(position + 5000)
            }}>⏩</Button></td>
          </tr>
        </tbody>
      </table>
    </div> }
    {revealed ? <div className={classes.SongInfo + ' pb-3 pt-3'}>
      <div>💿 {title}</div>
      <div>👤 {artist}</div>
      <div>{year}</div>
    </div> : <div className={classes.Position}>
      {Math.floor(position/60000).toString().padStart(2, "0")}:{Math.floor((position/1000) % 60).toString().padStart(2, "0")}
    </div>}
    <Stack gap={3} className={'pt-2'}>
      {revealed || <Button className={classes.StackButton} variant={'success'} onClick={_ => setRevealed(true)}><span>🫣</span> Reveal Song Data</Button>}
      <Button className={classes.StackButton} as={Link} to="/scan" variant={'danger'}><span>📸</span> Scan Again</Button>
    </Stack>
  </Container> : <div>Loading Spotify player...</div> )
}

export default ShitsterPlayer
